<template>
  <div id="settingsNotifications">

    <div class="name">Notification Settings</div>
    <div class="context">
      Manage your notifications with simplicity and ease. Select which notifications you would like enabled or disabled by tapping their respective checkboxes. By default, all notifications are enabled.
    </div>
    
    <div class="settings-content">
      
      <div class="type">Push Notifications</div>
      <div class="checkboxes">
        <v-checkbox class="checkbox" hide-details label="New Chat Message"     v-model="notificationSettings.ticketComment.push"      color="primary"></v-checkbox>
        <v-checkbox class="checkbox" hide-details label="Ticket Status Change" v-model="notificationSettings.ticketStatusChanged.push"     color="primary"></v-checkbox>
        <v-checkbox class="checkbox" hide-details label="New Ticket"           v-model="notificationSettings.ticketCreation.push"        color="primary"></v-checkbox>
        <v-checkbox class="checkbox" hide-details label="Assignee Updates"     v-model="notificationSettings.ticketAssigneeChanged.push"  color="primary"></v-checkbox>
        <v-checkbox class="checkbox" hide-details label="Ticket Resolved"      v-model="notificationSettings.ticketResolved.push"   color="primary"></v-checkbox>
        <template v-if="hasPropertyLevelAccess">
          <v-checkbox class="checkbox" hide-details label="New Ticket Note"      v-model="notificationSettings.ticketNote.push"    color="primary"></v-checkbox>
          <v-checkbox class="checkbox" hide-details label="Ticket Tags Change"   v-model="notificationSettings.ticketTagsChanged.push"    color="primary"></v-checkbox>
        </template>
      </div>

      <div class="type">Email Notifications</div>
      <div class="checkboxes">
        <v-checkbox class="checkbox" hide-details label="New Chat Message"     v-model="notificationSettings.ticketComment.email"     color="primary"></v-checkbox>
        <v-checkbox class="checkbox" hide-details label="Ticket Status Change" v-model="notificationSettings.ticketStatusChanged.email"    color="primary"></v-checkbox>
        <v-checkbox class="checkbox" hide-details label="New Ticket"           v-model="notificationSettings.ticketCreation.email"       color="primary"></v-checkbox>
        <v-checkbox class="checkbox" hide-details label="Assignee Updates"     v-model="notificationSettings.ticketAssigneeChanged.email" color="primary"></v-checkbox>
        <v-checkbox class="checkbox" hide-details label="Ticket Resolved"      v-model="notificationSettings.ticketResolved.email"   color="primary"></v-checkbox>
        <template v-if="hasPropertyLevelAccess">
          <v-checkbox class="checkbox" hide-details label="New Ticket Note"      v-model="notificationSettings.ticketNote.email"   color="primary"></v-checkbox>
          <v-checkbox class="checkbox" hide-details label="Ticket Tags Change"   v-model="notificationSettings.ticketTagsChanged.email"   color="primary"></v-checkbox>
          <v-checkbox class="checkbox" hide-details label="Daily Summary"        v-model="notificationSettings.dailyEmail.email"   color="primary"></v-checkbox>
        </template>
      </div>
    </div>

    <div class="buttons">
      <v-btn class="button" :loading="lockout" color="primary" flat @click="save()">Save</v-btn>
    </div>

    <div class="clear"></div>

  </div>

</template>

<script>

  import permissionMixin  from '../mixins/permissionMixin.js';

  export default {
    mixins: [permissionMixin],
    data () {
      return {
        notificationSettings: {
          dailyEmail: {

          },
          ticketAssigneeChanged: {

          },
          ticketComment: {

          },
          ticketCreation: {

          },
          ticketNote: {

          },
          ticketTagsChanged: {

          },
          ticketResolved: {

          },
          ticketStatusChanged: {

          }
        },
        lockout: false,
        hasPropertyLevelAccess: false
      }
    },

    methods: {
      save () {
        this.lockout = true;

        this.$store.dispatch('saveNotificationSettings', {
          notificationSettings: this.notificationSettings
        })
        .then(data => {
          Toast.show('Changes saved.', 'success');
          this.lockout = false;
        })
        .catch(e => {
          console.log(e);
          Toast.showError(e);
          this.lockout = false;
        });
      }
    },

    created () {
      this.notificationSettings = this.$store.getters.profile.notificationSettings;
      this.hasPropertyLevelAccess = this.hasPermissions(['ticketManager', 'ticketAdmin']);
    }
  }

</script>

<style lang="scss">

  @import '../css/global.scss';

  #settingsNotifications {

    position: relative;  
    
    .settings-content {

      padding: 24px !important;

      .checkboxes {

        padding: 0 0 0 8px;

        .checkbox {
          margin: 4px 0;
        }
      }

      .type {
        padding: 0 0 4px 4px;
        font-size: 16px;
        border-bottom: $borderBlack12;
        margin: 24px 0 10px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/SettingsNotifications.vue